import { render, staticRenderFns } from "./jiancha.vue?vue&type=template&id=e2f11fc8&scoped=true&"
import script from "./jiancha.vue?vue&type=script&lang=ts&"
export * from "./jiancha.vue?vue&type=script&lang=ts&"
import style0 from "./jiancha.vue?vue&type=style&index=0&id=e2f11fc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f11fc8",
  null
  
)

export default component.exports